module.exports = __webpack_public_path__ + "img/oktickgray.b5d55c8d.png";